import { View, Text } from "@react-pdf/renderer";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { styles } from "../../PdfDocument.styled";
import { AssetDetailsType } from "../../../../Questionnaires.types";

const formatDate = (dateString?: string): string => {
  if (!dateString) return "N/A";
  const date: Date = new Date(dateString);

  return !isNaN(date.getTime()) ? date.toLocaleDateString("en-GB") : "N/A";
};

interface AssetDetails {
  details: AssetDetailsType;
}

const AssetDetails: FC<AssetDetails> = ({ details }) => {
  const { t } = useTranslation();

  return (
    <View style={styles.section}>
      <Text style={styles.question}>
        {t("csob.pdf.assetName")}: {details.name}
      </Text>
      <Text style={styles.question}>
        {t("csob.pdf.questionnaireType")}: {details.type}
      </Text>
      <Text style={styles.question}>
        {t("csob.pdf.isGroupAsset")}: {details.isGroupAsset ? t("common.yes") : t("common.no")}
      </Text>
      <Text style={styles.question}>
        {t("csob.pdf.isHedgingAsset")}: {details.isHedgingAsset ? t("common.yes") : t("common.no")}
      </Text>
      <Text style={styles.question}>
        {t("csob.pdf.dateCreated")}: {formatDate(details.dateCreated)}
      </Text>
    </View>
  );
};

export default AssetDetails;
